import { default as Big } from 'big.js';

/* Use Big object to create and manage decimal values, see: https://github.com/MikeMcl/big.js
 * This file is a proxy for the actual big.js file but ensures it is configured in a standard way for our apps.
 */

// Division precision. The precision (decimal places) to round at when doing a division operation.
Big.DP = 20; // Max allowed by Big.js is 20.

// Rounding mode. How to round (ie up or down when 1/2 of rounding precision).
// See: http://mikemcl.github.io/big.js/#rm
Big.RM = 2; // 2: Half-even-rounding, aka banker's rounding. Least biased rounding, good for financial applications.

export { Big };